import 'react-toastify/dist/ReactToastify.min.css';

import { createContext, useContext, useMemo, useState } from 'react';

export type Process = {
  label: string;

  stages?: Process[];
};

type IProcessMonitorContext = {
  currentProcessStack: Process[];

  startProcess: <T>(
    closure: (process: Process) => Promise<T>,
    processDefinition: Process,
  ) => Promise<T>;
};

const initContext: IProcessMonitorContext = {
  currentProcessStack: [],

  startProcess: (closure, processDefiniton) => closure(processDefiniton),
};

const ProcessMonitorContext = createContext(initContext);

export const ProcessMonitorProvider: FCC = ({ children }) => {
  const [currentProcessStack, setCurrentProcessStack] = useState<Process[]>([]);

  return (
    <ProcessMonitorContext.Provider
      value={useMemo<IProcessMonitorContext>(
        () => ({
          currentProcessStack: currentProcessStack,
          startProcess: (closure, processDefinition) => {
            setCurrentProcessStack([...currentProcessStack, processDefinition]);

            return closure(processDefinition).finally(() => {
              setCurrentProcessStack([
                ...currentProcessStack.filter((p) => p !== processDefinition),
              ]);
            });
          },
        }),
        [currentProcessStack],
      )}
    >
      {children}
    </ProcessMonitorContext.Provider>
  );
};

export const useProcessing = () => useContext(ProcessMonitorContext);
